
import { useQuery } from '@apollo/client';
import { GET_MY_DISTRICT } from '@/graphql/queries';
import { GetMyDistrict } from '@/graphql/types';
import { districtVar } from '@/graphql/state';

export const useGetMyDistrict = () => (
    useQuery<GetMyDistrict>(GET_MY_DISTRICT, {
      fetchPolicy: 'cache-first',
      onCompleted(data) {
        if(data.getMyDistrict) {
          districtVar(data.getMyDistrict);
        }
      }
    })
);
